export interface ProviderFinancialsQuery {
  page: number;
  pageSize: number;
  sortModel: string | unknown[];
  filterModel: string | unknown[];
}

type ProviderFinancialsResponse =
  | {
      rows?: unknown[];
      rowData?: unknown[];
      data?: unknown[];
      total?: number | string;
      lastRow?: number | string;
      rowCount?: number | string;
    }
  | null
  | undefined;

export function providerFinancialRows(res: ProviderFinancialsResponse): unknown[] {
  return res?.rows ?? res?.rowData ?? res?.data ?? [];
}

export function providerFinancialTotal(res: ProviderFinancialsResponse): number {
  return Number(res?.total ?? res?.lastRow ?? res?.rowCount ?? 0) || 0;
}

export function buildProviderFinancialsQuery(options: {
  startRow: number;
  endRow: number;
  sortModel?: { colId?: string; sort?: string }[] | null;
  filterModel?: Record<string, any> | null;
}): ProviderFinancialsQuery {
  const windowSize = Math.max(options.endRow - options.startRow, 1);
  const pageSize = Math.min(200, windowSize);

  return {
    page: Math.floor(options.startRow / pageSize) + 1,
    pageSize,
    sortModel: serialize((options.sortModel ?? []).filter((sort) => !!sort.colId)),
    filterModel: serialize(options.filterModel),
  };
}

/** The API takes the AG Grid models as JSON strings, and nothing at all when there is nothing to apply. */
function serialize(model: unknown[] | Record<string, any> | null | undefined): string | unknown[] {
  const empty = !model || (Array.isArray(model) ? model.length === 0 : Object.keys(model).length === 0);
  return empty ? [] : JSON.stringify(model);
}
